import React from "react";

function MemberInformation({ user, index }) {
  return (
    <div className="w-full h-auto bg-[#404040] rounded-md">
      <div className="flex flex-row items-center">
        <div className="text-white ml-[10px] mr-[3px]">{index + 1}</div>
        <div className="flex-grow">
          <div className="text-white ml-[10px]">{user.userName}</div>
        </div>
        <div className="border border-white flex h-auto mt-[10px] mr-[20px] mb-[10px] rounded">
          <div className="flex bg-[#404040] items-center ml-[5px] mr-[5px]">
            <div>
              <i class="fa-solid fa-envelope mr-[5px] text-white"></i>
            </div>
            <div className="text-white">{user.userEmail}</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MemberInformation;
